const arr = [
    // 疫情防控亚朵给出(退订政策)
    {
        path: '/rule/epidemicCopywritingTips',
        component: () => import(/* webpackChunkName:"rule-epidemicCopywritingTips"*/'@/pages/rule/epidemicCopywritingTips.vue'),
        name: 'epidemicCopywritingTips',
        meta: {
            title: '公告',
        },
    },
    // 司航权益规则
    {
        path: '/rule/airplaneRightIntroduction',
        component: () => import(/* webpackChunkName:"rule-airplaneRightIntroduction"*/'@/pages/rule/airplaneRightIntroduction.vue'),
        name: 'airplaneRightIntroduction',
        meta: {
            title: '权益介绍',
        },
    },
    // 支付宝圈内规则使用
    {
        path: '/rule/alipayCouponRuleIntroduction',
        component: () => import(/* webpackChunkName:"rule-alipayCouponRuleIntroduction"*/'@/pages/rule/alipayCouponRule.vue'),
        name: 'alipayCouponRule',
        meta: {
            title: '限时优惠',
        },
    },
    // 签到活动-规则
    {
        path: '/rule/signEveryDay',
        component: () => import(/* webpackChunkName:"rule-signEveryDay"*/'@/pages/rule/activeSignRule.vue'),
        name: 'rule/signEveryDay',
        meta: {
            title: '活动规则',
            // wxConfig: ['updateTimelineShareData', 'updateAppMessageShareData', 'hideMenuItems', 'showMenuItems'],
        },
    },
    // 武汉引流规则
    {
        path: '/rule/memberDisperse',
        component: () => import(/* webpackChunkName:"rule-memberDisperse"*/'@/pages/rule/memberDisperse.vue'),
        name: 'rule/memberDisperse',
        meta: {
            title: '活动规则',
        },
    },
    // 六一活动规则
    {
        path: '/rule/childrenDay',
        component: () => import(/* webpackChunkName:"rule-childrenDay"*/'@/pages/rule/childrenDay.vue'),
        name: 'rule/childrenDay',
        meta: {
            title: '活动规则',
        },
    },
    {
        path: '/rule/memberRule',
        component: () => import(/* webpackChunkName:"rule-memberRule"*/'@/pages/rule/memberRule/index.vue'),
        name: 'rule/memberRule',
        meta: {
            title: '会员政策',
        },
    },
    // 用户协议
    {
        path: '/rule/userAgreement',
        component: () => import(/* webpackChunkName:"rule-userAgreement"*/'@/pages/rule/userAgreement.vue'),
        name: 'rule/userAgreement',
        meta: {
            title: '用户协议',
        },
    },
    {
        path: '/rule/serviceRule',
        component: () => import(/* webpackChunkName:"rule-serviceRule"*/'@/pages/rule/serviceRule.vue'),
        name: 'rule/serviceRule',
        meta: {
            title: '协议与条款',
        },
    },
    {
        path: '/rule/history/:date',
        component: () => import(/* webpackChunkName:"rule-history"*/'@/pages/rule/history/index.vue'),
        name: 'rule/serviceRuleDetail',
        meta: {
            title: '协议与条款',
        },
    },
    {
        path: '/rule/sharedList',
        component: () => import(/* webpackChunkName:"rule-sharedList"*/'@/pages/rule/sharedList.vue'),
        name: 'rule/sharedList',
        meta: {
            title: '个人信息共享清单',
        },
    },
    {
        path: '/rule/collectionList',
        component: () => import(/* webpackChunkName:"rule-collectionList"*/'@/pages/rule/collectionList.vue'),
        name: 'rule/collectionList',
        meta: {
            title: '个人信息收集清单',
        },
    },
    {
        path: '/rule/privacyPolicy',
        component: () => import(/* webpackChunkName:"rule-privacyPolicy"*/'@/pages/rule/privacyPolicy.vue'),
        name: 'rule/privacyPolicy',
        meta: {
            title: '隐私政策摘要',
        },
    },
    {
        path: '/rule/basicFunction',
        component: () => import(/* webpackChunkName:"rule-basicFunction"*/'@/pages/rule/basicFunction.vue'),
        name: 'rule/BasicFunction',
        meta: {
            title: '亚朵基本功能模式',
        },
    },
    // 永璞协议
    {
        path: '/rule/yongPuAgreement',
        component: () => import(/* webpackChunkName:"rule-yongPuAgreement"*/'@/pages/rule/yongPuAgreement.vue'),
        name: '/rule/yongPuAgreement',
        meta: {
            title: '用户协议与隐私',
        },
    },
    {
        path: '/rule/underAgeProtect',
        component: () => import(/* webpackChunkName:"rule-underAgeProtect"*/'@/pages/rule/underAgeProtect.vue'),
        name: 'rule/underAgeProtect',
        meta: {
            title: '未成年人个人信息保护规则',
        },
    },
    {
        path: '/rule/candidateInfoPolicy',
        component: () => import(/* webpackChunkName:"rule-candidateInfoPolicy"*/'@/pages/rule/candidateInfoPolicy.vue'),
        name: 'rule/candidateInfoPolicy',
        meta: {
            title: '亚朵候选人个人信息保护政策',
        },
    },
    {
        path: '/rule/appPermission',
        component: () => import(/* webpackChunkName:"rule-appPermission"*/'@/pages/rule/appPermission.vue'),
        name: 'rule/appPermission',
        meta: {
            title: '应用权限说明',
        },
    },
    {
        path: '/rule/idCardUseAgreement',
        component: () => import(/* webpackChunkName:"rule-idCardUseAgreement"*/'@/pages/rule/idCardUseAgreement.vue'),
        name: 'rule/idCardUseAgreement',
        meta: {
            title: '身份证件信息授权协议书',
        },
    },
    // 新客八折 身份证协议
    {
        path: '/rule/idCardUseAgreementNewGuest',
        component: () => import(/* webpackChunkName:"rule-idCardUseAgreement"*/'@/pages/rule/idCardUseAgreementNewGuest.vue'),
        name: 'rule/idCardUseAgreementNewGuest',
        meta: {
            title: '身份证件使用协议',
        },
    },
    // 新客八折 查看详细说明 协议
    {
        path: '/rule/newGuestAgreement',
        component: () => import(/* webpackChunkName:"rule-newGuestAgreement"*/'@/pages/rule/newGuestAgreement.vue'),
        name: 'rule/newGuestAgreement',
        meta: {
            title: '',
        },
    },
    /* 小程序隐私政策 start */
    {
        path: '/rule/miniApp/privacyPolicy',
        component: () => import(/* webpackChunkName:"rule-miniApp"*/'@/pages/rule/miniApp/privacyPolicy.vue'),
        name: 'miniApp/privacyPolicy',
        meta: {
            title: '隐私政策摘要',
        },
    },
    {
        path: '/rule/miniApp/serviceRule',
        component: () => import(/* webpackChunkName:"rule-miniApp"*/'@/pages/rule/miniApp/serviceRule.vue'),
        name: 'miniApp/serviceRule',
        meta: {
            title: '协议与条款',
        },
    },
    {
        path: '/rule/miniApp/collectionList',
        component: () => import(/* webpackChunkName:"rule-miniApp"*/'@/pages/rule/miniApp/collectionList.vue'),
        name: 'miniApp/collectionList',
        meta: {
            title: '个人信息收集清单',
        },
    },
    {
        path: '/rule/miniApp/sharedList',
        component: () => import(/* webpackChunkName:"rule-miniApp"*/'@/pages/rule/miniApp/sharedList.vue'),
        name: 'miniApp/sharedList',
        meta: {
            title: '个人信息共享清单',
        },
    },
    {
        path: '/rule/miniApp/qsUserAgreement',
        component: () => import(/* webpackChunkName:"rule-miniApp"*/'@/pages/rule/miniApp/qsUserAgreement.vue'),
        name: 'miniApp/qsUserAgreement',
        meta: {
            title: '用户协议',
        },
    },
    {
        path: '/rule/miniApp/qsPersonalInfoAuth',
        component: () => import(/* webpackChunkName:"rule-miniApp"*/'@/pages/rule/miniApp/qsPersonalInfoAuth.vue'),
        name: 'miniApp/qsPersonalInfoAuth',
        meta: {
            title: '个人信息授权使用协议',
        },
    },
    /* 小程序隐私政策 end */
    // 亚朵企业会员协议
    {
        path: '/rule/corporateMembers',
        component: () => import(/* webpackChunkName:"rule-corporate"*/'@/pages/rule/corporateMembers.vue'),
        name: 'rule/corporateMembers',
        meta: {
            title: '亚朵企业会员',
        },
    },
    // 企业会员协议
    {
        path: '/rule/corporateMemberAgreement',
        component: () => import(/* webpackChunkName:"rule-corporateMemberAgreement"*/'@/pages/rule/corporateMemberAgreement.vue'),
        name: 'rule/corporateMemberAgreement',
        meta: {
            title: '企业会员协议',
        },
    },
    {
        path: '/rule/marketResearch',
        component: () => import(/* webpackChunkName:"rule-corporateMemberAgreement"*/'@/pages/rule/marketResearch.vue'),
        name: 'rule/marketResearch',
        meta: {
            title: '上海市场零点有数市场调查隐私政策',
        },
    },
];
export default arr;
